<template>
  <div class="vehicles card">
    <page-header title="Fleets" breadcrumbText="Dashboard >> Fleets" />
    <fleets-table />
  </div>
</template>

<script>
import FleetsTable from "./FleetsTable";
export default {
  components: {
    FleetsTable,
  },
};
</script>

<style></style>
